import timePeriodList from "./time-period";
import reviewTypeByTimePeriodList from "./review-type-in-time";
import reviewerTypeList from "./reviewer-type-list";

export default [...timePeriodList, ...reviewTypeByTimePeriodList, ...reviewerTypeList];
